export const DASHBOARD_COLUMNS = 12;
export const DASHBOARD_GAP = 8;
export const DASHBOARD_ROW_UNIT = 8;
export const DASHBOARD_MAX_PREFERRED_ROW = 10000;

export const DASHBOARD_SECTION_IDS = ['hero', 'highlights', 'operations'] as const;
export type DashboardSectionId = (typeof DASHBOARD_SECTION_IDS)[number];

export const DASHBOARD_MODULE_KEYS = [
  'OnlinePaymentSales',
  'Insurance',
  'OnTimeRent',
  'PaidSupport',
  'DailyMoneyMovement',
  'ReturnsAndDisputes',
  'LeasesWithBalanceDue',
  'RentalApplications',
  'MaintenanceRequests',
  'UnreadMessages',
] as const;

export type DashboardModuleKey = (typeof DASHBOARD_MODULE_KEYS)[number];

export type DashboardWidgetPlacement = {
  key: DashboardModuleKey;
  sectionId: DashboardSectionId;
  x: number;
  preferredRow: number;
  width: number;
  fillEmptySpace: boolean;
  layoutOrder: number;
  mobileOrder: number;
};

export type DashboardLayoutConfig = {
  placements: DashboardWidgetPlacement[];
  disabledModuleKeys: DashboardModuleKey[];
};

export type DashboardWidgetHeightPolicy = { mode: 'intrinsic' } | { mode: 'fixed'; height: number };

export type DashboardModuleDefinition = {
  key: DashboardModuleKey;
  thumbnail: string;
  title: string;
  description: string;
  defaultPlacement: DashboardWidgetPlacement;
  minWidth: number;
  maxWidth: number;
  heightPolicy: DashboardWidgetHeightPolicy;
  permissions?: {
    resource: string;
    action: string;
  };
  mandatory?: boolean;
};

export type DashboardResolvedModule = {
  definition: DashboardModuleDefinition;
  placement: DashboardWidgetPlacement;
};

export type DashboardWidgetMeasurement = {
  key: DashboardModuleKey;
  measuredWidth: number;
  measuredHeight: number;
};

export type DashboardRuntimePlacement = {
  key: DashboardModuleKey;
  left: number;
  top: number;
  width: number;
  height: number;
  fillHeight?: number;
};

export type DashboardSectionLayout = {
  placements: DashboardRuntimePlacement[];
  height: number;
  ready: boolean;
};
